import IconUp from 'Icons/bold/IconUp';
import IconUpFull from 'Icons/bold/IconUpFull';

import ModalPedagogyTicketResto from 'Components/modals/ModalPedagogyTicketResto';

import { SET_DEFAULT_CARD_ACTION } from 'Stores/types/userActionsTypes';

import { openModal } from 'Plugins/potagerModals';

import { storeDispatch } from 'Services/storeServices';
import { routerPush } from 'Services/routerServices';

import { PaymentMethods } from 'PotagerLogic/Enums/PaymentMethods';

export default {
  ...PaymentMethods.Up,
  route: {
    name: 'mon-compte_payment-methods_cards',
    params: { name: PaymentMethods.Up.name },
  },
  defaultIcon: IconUp,
  icons: [IconUp],
  alternativeIcons: [IconUpFull],
  loaders: {
    editSettings: SET_DEFAULT_CARD_ACTION,
    editSettingsByCardId: (cardId) => `${SET_DEFAULT_CARD_ACTION}_${cardId}`,
  },

  actions: {
    openAddModal: (app, onSuccess, onClose) => {
      openModal(ModalPedagogyTicketResto,
        {
          name: PaymentMethods.Up.name,
          cardIconComponent: IconUp,
          cardIconFullComponent: IconUpFull,
          cardIconColor: '#FFFFFF',
        },
        (e) => {
          if (typeof onClose === 'function') onClose();
          if (e.params?.type === 'success' && typeof onSuccess === 'function') onSuccess();
        });
    },

    redirect() {
      routerPush({
        name: 'mon-compte_payment-methods_paygreen_add',
        params: { name: PaymentMethods.Up.name },
      });
    },

    setDefault(cardId, isDefault) {
      storeDispatch(`user/${SET_DEFAULT_CARD_ACTION}`, {
        cardId,
        isDefault
      });
    },
  },
};
